const axios = require('axios');
import api from '../../api';

export default {
    namespaced: true,
    state: {
        definitions: [],
        cancelTokens: {}
    },
    getters: {
        getDefinitions(state) {
            return state.definitions;
        },
        getDefinitionById: (state) => (id) => {
            return state.definitions.find(def => def.id === id);
        },
        baseEndpoint(state, getters, rootState, rootGetters) {
            if (rootGetters['user/exists']) return '/dataElements';
            return `${rootGetters['filler/baseEndpoint']}/dataElements`;
        },
        getCancelTokens: state => inputId => {
            return state.cancelTokens[inputId] ? state.cancelTokens[inputId] : [];
        }
    },
    mutations: {
        setDefinitions(state, definitions) {
            state.definitions = definitions;
        },
        cancelTokenPush(state, { inputId, source }) {
            if (state.cancelTokens[inputId] === undefined) state.cancelTokens[inputId] = [];
            state.cancelTokens[inputId].push(source);
        },
        cancelTokenRemove(state, { inputId, source }) {
            if (state.cancelTokens[inputId] === undefined) {
                let index = state.cancelTokens[inputId].findIndex(t => t === source);
                if (index !== -1) state.cancelTokens[inputId].splice(index, 1);
            }
        }
    },
    actions: {
        async loadDataElementDefinitions({ commit }) {
            let definitions = await api.get(`dataElements/definitions`);

            commit('setDefinitions', definitions);
        },
        async search({ dispatch, commit }, { terms, offset = 0, limit = 10, sortBy, definitionId, inputId }) {
            dispatch('cancelPendingSearches', inputId);

            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            commit('cancelTokenPush', { inputId, source });

            let res = await api.post(`dataElements/data/def/${definitionId}`,
                { terms, offset, limit, sortBy },
                { cancelToken: source.token });

            commit('cancelTokenRemove', { inputId, source });
            return res;
        },
        async cancelPendingSearches({ getters, commit }, inputId) {
            getters.getCancelTokens(inputId).forEach(source => {
                source.cancel();
                commit('cancelTokenRemove', { inputId, source });
            });
        },
        async updateDataElement({ commit, rootGetters }, { dataElementData = {}, formId, dataElementFeature }) {
            // update the data element feature
            let dataElementValue = '';

            if (Object.keys(dataElementData).length) {
                let field = dataElementFeature.dataElementDisplayField;
                if (field === 'fullname') {
                    dataElementValue = `${dataElementData.fname} ${dataElementData.lname}`;
                } else if (field === 'fullnameReversed') {
                    dataElementValue = `${dataElementData.lname}, ${dataElementData.fname}`;
                } else {
                    dataElementValue = dataElementData[field] ? dataElementData[field].toString() : '';
                }
            }

            commit('filler/fieldData', {
                formId: formId,
                fieldId: dataElementFeature.id,
                data: {
                    selectedDataElementDataId: dataElementData.id,
                    value: dataElementValue
                },
                init: false
            }, { root: true });


            // update all linked features
            let linkedFeatures = rootGetters['form/features'].filter(f => {
                return f.linkedDataElementFeatureId === dataElementFeature.id;
            });

            linkedFeatures.forEach(feature => {
                // TODO cast to correct type based on definition
                let value = dataElementData && dataElementData[feature.linkedDataElemProp]
                    ? dataElementData[feature.linkedDataElemProp].toString()
                    : '';

                commit('filler/fieldData', {
                    formId: formId,
                    fieldId: feature.id,
                    data: { value },
                    init: false
                }, { root: true });
            });
        },

        async getData({ getters }, dataElementDataId) {
            return await api.get(`${getters.baseEndpoint}/data/${dataElementDataId}`);
        },
        async insertData({ }, { definitionId, data }) {
            return await api.post(`/dataElements/data/${definitionId}`, { data });
        },
        async updateData({ }, { dataId, data }) {
            return await api.put(`/dataElements/data/${dataId}`, { data });
        },
        async deleteData({ }, dataId) {
            return await api.delete(`/dataElements/data/${dataId}`);
        }
    }
}